module.exports = __webpack_public_path__ + "webpc/img/no_data.16c18166.png";